// extracted by mini-css-extract-plugin
export default {"empty":"WidgetEmpty_empty__pwICL","icon":"WidgetEmpty_icon__QM3pd","title":"WidgetEmpty_title__8Uafm","hint":"WidgetEmpty_hint__GF76d"};